/** Filtro de período. Va en una sola fila, encima del contenido. */

import type { Period } from "./period";

interface Props {
  value: Period;
  onChange: (period: Period) => void;
  children?: React.ReactNode;
}

export function PeriodPicker({ value, onChange, children }: Props) {
  return (
    <div className="toolbar">
      <div className="field">
        <label htmlFor="period-from">Desde</label>
        {/* `max` y `min` se atan CRUZADOS entre los dos campos: el calendario
            nativo apaga los días imposibles, así que el rango invertido no se
            puede ni construir. Sin esto se podía pedir «del 1 de diciembre al 9
            de septiembre», y el documento salía con «Sin datos para el período
            seleccionado» — que en un entregable contable se lee como «no hubo
            movimientos», y es otra cosa. El backend lo rechaza además con un
            422: el navegador no es la frontera. */}
        <input
          id="period-from"
          type="date"
          max={value.periodTo || undefined}
          value={value.periodFrom}
          onChange={(event) => onChange({ ...value, periodFrom: event.target.value })}
        />
      </div>
      <div className="field">
        <label htmlFor="period-to">Hasta</label>
        <input
          id="period-to"
          type="date"
          min={value.periodFrom || undefined}
          value={value.periodTo}
          onChange={(event) => onChange({ ...value, periodTo: event.target.value })}
        />
      </div>
      <div className="spacer" />
      {children}
    </div>
  );
}
